import axios from "axios";
import { Auth } from "aws-amplify";
import { config } from "../configs";
import { getSessionToken } from "./getToken";
import { getUserOrgs } from "./org";

const getUserProfileData = () => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/user/profile`;
      const response = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Organization: 0,
          Application: "Platform",
        },
        url,
      });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

const createUserProfile = (attributes) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/user/userprofile`;
      const { status } = await axios({
        method: "PUT",
        headers: {
          Authorization: jwtToken,
          Organization: 0,
          Application: "Platform",
        },
        data: attributes,
        url,
      });
      resolve(status);
    } catch (error) {
      reject(error);
    }
  });
};

const updateUserProfile = (attributes) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/user/profile`;
      const { status } = await axios({
        method: "PATCH",
        headers: {
          Authorization: jwtToken,
          Organization: 0,
          Application: "Platform",
        },
        data: attributes,
        url,
      });
      resolve(status);
    } catch (error) {
      reject(error);
    }
  });
};

const getUserInfo = () => {
  return new Promise(async function (resolve, reject) {
    Auth.currentUserInfo()
      .then((response) => {
        resolve(response?.attributes);
      })
      .catch((error) => reject(error));
  });
};

// Get applications the user is subscribed to.
const getApplications = () => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      let orgs = await getUserOrgs();
      const newData = [];

      for (const org of orgs) {
        let orgId = org?.id;
        const url = `${config.baseURL}/applications?withurls=true`;
        const { data } = await axios({
          method: "GET",
          headers: {
            Authorization: jwtToken,
            Application: "Platform",
            Organization: orgId,
          },
          url: url,
        });
        newData.push(...data);
      }
      resolve({ apps: newData });
    } catch (error) {
      reject(error);
    }
  });
};

const createOrUpdateUserRole = (attributes, orgId) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/user/roles`;
      const { status } = await axios({
        method: "PUT",
        headers: {
          Authorization: jwtToken,
          Organization: orgId,
          Application: "Platform",
        },
        data: attributes,
        url,
      });
      resolve(status);
    } catch (error) {
      reject(error);
    }
  });
};

export {
  getUserProfileData,
  getUserInfo,
  createUserProfile,
  updateUserProfile,
  getApplications,
  createOrUpdateUserRole
};
